module.exports = __webpack_public_path__ + "static/media/400-bottles-of-beer.40d869b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/beers/400-bottles-of-beer.jpg
// module id = 601
// module chunks = 0